var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.6667C16.5 15.1453 16.244 15.5867 15.828 15.824L11.1613 18.4907C10.9533 18.6093 10.7253 18.6667 10.5013 18.6667C10.0373 18.6667 9.588 18.4253 9.34267 17.9947C8.97733 17.356 9.2 16.5413 9.83867 16.176L13.8333 13.8933V8C13.8333 7.264 14.4293 6.66667 15.1667 6.66667C15.904 6.66667 16.5 7.264 16.5 8V14.6667ZM32.5 22.6667V28C32.5 30.2053 30.7053 32 28.5 32H20.5C18.2947 32 16.5 30.2053 16.5 28V22.6667C16.5 20.9307 17.6187 19.464 19.1667 18.912V17.3333C19.1667 16.5973 19.7627 16 20.5 16C21.2373 16 21.8333 16.5973 21.8333 17.3333V18.6667H27.1667V17.3333C27.1667 16.5973 27.7627 16 28.5 16C29.2373 16 29.8333 16.5973 29.8333 17.3333V18.912C31.3813 19.464 32.5 20.9307 32.5 22.6667ZM29.8333 28V24H19.1667V28C19.1667 28.7347 19.764 29.3333 20.5 29.3333H28.5C29.236 29.3333 29.8333 28.7347 29.8333 28ZM12.7653 26.4267C7.20267 25.2973 3.16667 20.352 3.16667 14.6667C3.16667 8.05067 8.54933 2.66667 15.1667 2.66667C20.852 2.66667 25.7973 6.704 26.9253 12.2653C27.072 12.9867 27.7733 13.456 28.4987 13.3067C29.22 13.16 29.6867 12.456 29.54 11.7347C28.1587 4.93467 22.1147 0 15.1667 0C7.08 0 0.5 6.58 0.5 14.6667C0.5 21.6147 5.43467 27.66 12.2347 29.04C12.324 29.0587 12.4147 29.0667 12.5013 29.0667C13.1227 29.0667 13.6787 28.6307 13.8067 27.9987C13.952 27.2773 13.4867 26.5733 12.7653 26.4267Z",
    fill: "#F68868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.397666bc7e28355f20b4c54eef7065f8.svg";
export { ForwardRef as ReactComponent };